import Axios from "axios";

const loginByToken = (baseUrl: string, refreshToken: string) => {
    return Axios.post(`${baseUrl}/login/byToken`, `"${refreshToken}"`, {
        headers: {
            "Content-Type": "application/json-patch+json"
        }
    })
        .then(({data}) => data)
        .catch(() => Promise.reject());
}

export { loginByToken };